import React from 'react';
import { ListGroup } from 'react-bootstrap';
import NavCollapse from '../NavCollapse';
import NavItem from '../NavItem';
import { getFieldFromJwtToken } from './../../../../../utils/authUtils'

const NavGroup = ({ layout, group }) => {
    let navItems = '';

    if (group.children) {
        const groups = group.children;
        navItems = Object.keys(groups).map((item) => {
            item = groups[item];
            if (item.id == 'userItem') {

                let userName = getFieldFromJwtToken('username')
                if (userName == '')
                    userName = 'userName'
                    
                item.title = userName;

                let organization = getFieldFromJwtToken('organization')
                item.bottomText = organization
                
            }
        
            switch (item.type) {
                case 'collapse':
                    return <NavCollapse key={item.id} collapse={item} type="main" />;
                case 'item':
                    return <NavItem layout={layout} key={item.id} item={item} />;
                default:
                    return false;
            }
        });
    }

    return (
        <React.Fragment>
            <ListGroup.Item as="li" bsPrefix=" " key={group.id} className="nav-item pcoded-menu-caption">
                <label>{group.title}</label>
            </ListGroup.Item>
            {navItems}
        </React.Fragment>
    );
};

export default NavGroup;
